import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import log from 'loglevel'
import { showInfoToast } from 'src/Utils/helpers/toast'
import { useInAudit } from 'src/context/AuditContext'
import { BasicDropdownMenuItem } from 'src/components/Reusable/BasicDropdown/BasicDropdown.styles'
import { Spinner, useThrobberContext } from '../../../../Throbber'
import { useCloseAudit } from '../AuditIndex.hooks'
import { AuditsIndexRoute } from '../AuditIndexPage'

export const CloseAudit = ({
  auditId,
  eventKey,
}: {
  auditId: string
  eventKey: string
}): JSX.Element => {
  const closeAudit = useCloseAudit()
  const { auditId: currentAuditId } = useInAudit()
  const { pageContext } = useParams()
  const navigate = useNavigate()
  const { setThrobberState } = useThrobberContext()

  const onCloseAudit = async (e: React.MouseEvent) => {
    e.preventDefault()
    setThrobberState({
      isShown: true,
      Display: <Spinner color="primary" size="xl" />,
    })
    try {
      await closeAudit(auditId)
      showInfoToast(
        'Audit closed successfully. We are generating your Work Papers and will email you when they are ready.',
      )
    } catch (err) {
      log.error(`Error closing audit for id ${auditId}`, err)
    } finally {
      setThrobberState({
        isShown: false,
        Display: <></>,
      })
      if (currentAuditId === auditId) {
        const continuousCompliancePath = pageContext?.split(':')[0]
        navigate(
          `/${continuousCompliancePath}/${AuditsIndexRoute}?show_audits=true`,
        )
      }
    }
  }

  return (
    <BasicDropdownMenuItem eventKey={eventKey} onClick={onCloseAudit}>
      Close Audit
    </BasicDropdownMenuItem>
  )
}
